import Extern from '@lib/layouts/Extern/Main.vue';
import Login from '@lib/pages/Extern/Login.vue';

// Default routes
const children = [
	// Guests only like its siblings, but a signed-in user lands on the dashboard rather than the
	// 404: the SSO callback and an IdP's app tile open /login?token=... with a session still held
	{
		path: 'login',
		name: 'Login',
		component: Login,
		meta: { auth: { roles: false, notFoundRedirect: { name: 'Home' } } },
	},
	{ path: 'verify-email', name: 'VerifyEmail', component: () => import('@lib/pages/Extern/VerifyEmail.vue') },
	{ path: 'forgot-password', name: 'ForgotPassword', component: () => import('@lib/pages/Extern/PasswordReset.vue') },
	{ path: 'reset-password', name: 'ResetPassword', component: () => import('@lib/pages/Extern/NewPassword.vue') },
	{ path: 'set-password', name: 'SetPassword', component: () => import('@lib/pages/Extern/SetPassword.vue') },
	// The legal pages are for everyone: auth null overrides the guests only of the layout route,
	// vue-auth3 reads the deepest matched route that names auth
	{ path: '/privacy', component: () => import('@lib/pages/Extern/Privacy.vue'), meta: { auth: null } },
	{ path: '/legal', component: () => import('@lib/pages/Extern/Legal.vue'), meta: { auth: null } },
	{ path: '/disclosure', component: () => import('@lib/pages/Extern/Disclosure.vue'), meta: { auth: null } },
];

// Optional routes dependend on featuere flags
if (globalThis.env?.app?.self_registration === true) {
	children.push({
		path: 'register',
		name: 'Register',
		component: () => import('@lib/pages/Extern/Register.vue'),
	});
}

export default [
	{
		path: '/',
		redirect: '/login',
		component: Extern,
		meta: { auth: false, requiresAuth: false },
		children,
	},
];
